'use strict';

import { graphql } from 'react-relay';

export const sbRespRoot = graphql`
    query sbRespRootQuery(
        $userId: String = ""
        $fetchUser: Boolean!
        $uriRef: String = ""
        $first: Int!
        $page: Int!
        $dotComHost: String = ""
        $isTrade: Boolean!
        $showSeller: Boolean!
        $showModules: Boolean = true
        $followSearchPages: [String]
        $followSearchTypes: [types] = [SEARCH]
        $contentModuleId: String = ""
    ) {
        viewer {
            ...getDomainLinksSb_viewer
            ...SbRespLayout_viewer
            ...detectPageExistsAndRedirect_viewer
        }
    }
`;
